import { Link } from 'gatsby'

interface Props {
  buttonMessage: string
  buttonLink: string
  visibilityClasses?: string
}

const ButtonVitrineNewClubDecathlon = ({
  buttonMessage = 'Me tornar membro clube',
  buttonLink = '/login',
  visibilityClasses = '',
}: Props) => {
  return (
    <div
      className={`w-full h-[162px] flex flex-col justify-init items-center md:h-[250.5px] ${visibilityClasses}`}
    >
      <Link to={buttonLink}>
        <button className="w-[339px] h-[48px] border rounded-full border-[#B3BAC3] font-semibold text-[16px] leading-[24px] font-inter md:w-[1282px] hover:bg-[#B3BAC3]">
          {buttonMessage}
        </button>
      </Link>
    </div>
  )
}

export default ButtonVitrineNewClubDecathlon
